import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9x9dfusr4t: FaireBrandEntity = {
  token: "b_9x9dfusr4t",
  type: "brand",
  name: "Ever-Pretty",
  avatarUrl:
    "https://cdn.faire.com/fastly/095560ff666dcfc418d466a9b71c51dceb5cb2d02f031454a4fbaa53213bcf96.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c3e6b9b24acaef71f31ec4ac0f44cb3a88ba69bcf812aa759122afaa7b29753a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/095560ff666dcfc418d466a9b71c51dceb5cb2d02f031454a4fbaa53213bcf96.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c3e6b9b24acaef71f31ec4ac0f44cb3a88ba69bcf812aa759122afaa7b29753a.jpeg",
  location: "Irvine, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.6,
  reviewCount: 111,
  isInsider: true,
  description:
    "Since its founding in 2005, Ever-Pretty has been dedicated to creating high-quality and professional formalwear products to serve global customers. We offer a wide range of products, including evening dresses, wedding gowns, bridesmaid dresses, and flower girl dresses. With over 500,000 items in stock, more than 1,000 styles, and 50+ colors, we can meet your needs for any occasion. Choosing Ever-Pretty means partnering with a reliable ally, as we are committed to providing you with high-quality products and exceptional service. Join us and let's build a successful and long-lasting partnership together.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.724Z",
    importedBy: "entity-db-cli",
  },
};
